<template>
  <div id="SentimentCat">
    <!-- <Breadcrumb :list="list"/> -->
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="datepickerwrap" style="text-align: left">
      <div class="leftcontent wrapitem">
        <datecomponent ref="datecomponent"></datecomponent>
        <div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            Submit
          </button>
        </div>
        <div class="datebox" style="min-width: 10% !important; width: 10%">
          <button class="btn btn-block weavrpurple" @click="createPdf">Download</button>
        </div>
        <div class="datebox">
          <button
            style="padding-left: 0; padding-right: 0"
            class="btn btn-block weavrpurple"
            @click="downloadExcel"
          >
            Download Review
          </button>
        </div>
        <div class="datebox">
          <p class="channel-title">Channel:</p>
          <select
            @change="processCategory"
            v-model="channelSelector"
            class="form-control"
          >
            <!-- <option value="">All </option> -->
            <option value="amazon">Amazon</option>
            <!-- <option value="flipkart">Flipkart</option> -->
            <!-- <option value="walmart">Walmart </option>
            <option value="BESTBUY">Best Buy </option>
            <option value="jd">JD</option>
            <option value="costco">Costco </option>
            <option value="hp">HP </option> -->
          </select>
        </div>
        <div class="datebox">
          <select
            @change="icChanged"
            v-model="selectedItemCategory"
            class="form-control text-uppercase"
          >
            <option v-for="d in itemCategory" :value="d" :key="d.key">
              {{ d.value }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div id="sentimentPdf">
        <h5 class="positive-head">Positive</h5>
        <b-row>
          <b-col class="custCols" sm="4" lg="4" :key="idx" v-for="(ud, idx) in products">
            <div data-html2canvas-ignore="true" style="margin: 0 1px 6px 1px">
              <select
                @change="changeProduct(ud, idx)"
                v-model="selectedProducts[idx]"
                class="form-control text-uppercase"
              >
                <optgroup label="Primary">
                  <option v-for="d in primaryProductsOptions" :value="d.product_name">
                    {{ d.product_name.toUpperCase() }}
                  </option>
                </optgroup>
                <optgroup label="Competitor">
                  <option v-for="d in nonPrimaryProductsOptions" :value="d.product_name">
                    {{ d.product_name.toUpperCase() }}
                  </option>
                </optgroup>
              </select>
            </div>
            <b-card
              class="positive-border"
              style="background: #f5f5f580"
              v-if="defaultWords[ud.product_name] && renderCloud"
            >
              <h5 class="cust-head">{{ ud.product_name.toUpperCase() }}</h5>
              <!-- {{ defaultWords[d.product_name] }} -->
              <highcharts :options="defaultWords[ud.product_name].positive"></highcharts>
            </b-card>
          </b-col>
        </b-row>
        <h5 class="negative-head">Negative</h5>
        <b-row>
          <b-col class="custCols" sm="4" lg="4" :key="idx" v-for="(ud, idx) in products">
            <b-card
              class="negative-border"
              style="background: #f5f5f580"
              v-if="defaultWords[ud.product_name] && renderCloud"
            >
              <h5 class="cust-head">{{ ud.product_name.toUpperCase() }}</h5>
              <highcharts :options="defaultWords[ud.product_name].negative"></highcharts>
            </b-card>
          </b-col>
        </b-row>
        <h5 class="positive-head">All</h5>
        <b-row>
          <b-col class="custCols" sm="4" lg="4" :key="idx" v-for="(ud, idx) in products">
            <b-card>
              <h5 class="cust-head">{{ ud.product_name.toUpperCase() }}</h5>
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th scope="col">Keyword</th>
                    <th scope="col">Frequency</th>
                    <th scope="col">Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="d in tableData[ud.product_name]"
                    v-if="tableData[ud.product_name].length"
                  >
                    <td>
                      <span
                        style="color: blue; cursor: pointer"
                        @click="openModal(d.word, ud.product_name, '')"
                        >{{ d.word }}</span
                      >
                    </td>
                    <td>
                      <div class="greenbg">{{ d.positive_frequency | format }}</div>
                      <div class="redbg">{{ d.negative_frequency | format }}</div>
                    </td>
                    <td>
                      <div v-if="renderChart">
                        <div v-if="charts[ud.product_name][d.word]">
                          <highcharts
                            style="width: 100%; height: 89px"
                            :options="charts[ud.product_name][d.word]"
                          ></highcharts>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal size="lg" :title="modalTitle" v-model="showModal">
      <div class="customdim" v-show="modalLoader">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="leftcontent wrapitem">
        <datecomponent ref="modaldatecomponent" :noSaveProp="true"></datecomponent>
        <div class="datebox">
          <button
            @click="refreshModal('modaldatecomponent')"
            class="btn btn-block weavrpurple"
            type="button"
          >
            Submit
          </button>
        </div>
      </div>
      <b-card style="margin-top: 10px">
        <div class="cust-head" style="">
          <h4
            style="display: inline-block; padding-top: 10px; text-transform: capitalize"
          >
            {{ chartDataKey.split("_").join(" ") }}
          </h4>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group
              class="mr-3 radiohide"
              id="radiosBtn"
              buttons
              button-variant="outline-secondary"
              @change="getKeywordChartData"
              v-model="interval"
              name="radiosBtn"
            >
              <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              <b-form-radio class="mx-0" value="week">Week</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <span class="float-right">
            <select
              class="customselect"
              @change="processChartData"
              v-model="chartDataKey"
            >
              <option value="frequency">Frequency</option>
              <option value="score">Score</option>
              <option value="reviews_count">Review Count</option>
            </select>
          </span>
        </div>
        <highcharts :options="modalChart" v-if="activeModalChart"></highcharts>
        <div v-if="!activeModalChart">No data</div>
      </b-card>
      <div class="datebox" style="width: unset !important">
        <button
          :class="{ highlight_primary: modalSentimentType == '' }"
          @click="changeSentimentType('')"
          class="btn btn-primary"
          style="border-radius: 0; margin-right: 5px"
        >
          All
        </button>
        <button
          :class="{ highlight_success: modalSentimentType == 'positive' }"
          @click="changeSentimentType('positive')"
          class="btn btn-success"
          style="border-radius: 0; margin-right: 5px"
        >
          Positive
        </button>
        <button
          :class="{ highlight_danger: modalSentimentType == 'negative' }"
          @click="changeSentimentType('negative')"
          class="btn btn-danger"
          style="border-radius: 0; margin-right: 5px"
        >
          Negative
        </button>
      </div>
      <div class="reviews-panel">
        <div v-for="d in modalData.data" class="each-review">
          <div class="usericon">
            <i class="fa fa-user" style="font-size: 15px; color: silver"></i>
          </div>
          <div class="username">
            {{ d.person_name }}
          </div>
          <div class="usertimestamp">
            {{ d.review_date }}
          </div>
          <div class="helpful">
            Helpful: {{ d.found_helpful }}
            <a :href="d.review_link" target="_blank"> Link </a>
          </div>
          <div class="usertext">
            {{ d.review }}
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CardLine1ChartExample from ".././dashboard/CardLine1ChartExample";
import CardLine2ChartExample from ".././dashboard/CardLine2ChartExample";
import CardLine3ChartExample from "../dashboard/CardLine3ChartExample";
import CardBarChartExample from ".././dashboard/CardBarChartExample";
import MainChartExample from ".././dashboard/MainChartExample";
import SocialBoxChartExample from ".././dashboard/SocialBoxChartExample";
import CalloutChartExample from ".././dashboard/CalloutChartExample";
import { Callout } from "@coreui/vue";
import moment from "moment";
import datecomponent from "./DateMotherCare.vue";
export default {
  name: "Sentiment",
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    datecomponent,
  },

  data: function () {
    return {
      showModal: false,
      renderChart: false,
      selected: "",
      modalLoader: false,
      keywordChartData: {},
      modalTitle: "",
      modalProductName: "",
      renderCloud: false,
      modalSentimentType: "",
      tableData: {},
      modalData: {},
      modalChart: {},
      chartDataKey: "frequency",
      interval: "month",
      activeModalChart: false,
      data: [],
      loader: true,
      userData: JSON.parse(localStorage.getItem("reviewUserData")),
      customData: JSON.parse(localStorage.getItem("reviewCustomData")),
      products: [],
      nonPrimaryProductsOptions: [],
      primaryProductsOptions: [],
      selectedProducts: [],
      channelSelector: "",
      brand: "maharaja",
      charts: {},
      date: {
        startDate: moment().subtract(1, "year").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      myColors: [
        "darkgreen",
        "lightgreen",
        "mediumseagreen",
        "lightseagreen",
        "darkblue",
        "blue",
        "lightskyblue",
        "yellow",
        "orange",
        "red",
      ],
      defaultWords: {},
      itemCategory: [],
      selectedItemCategory: {},
      productList: {},
      competitorData: {},
    };
  },

  mounted() {
    if (localStorage.demo_voc_channelSelector)
      this.channelSelector = localStorage.demo_voc_channelSelector;
    else this.channelSelector = "amazon";
    this.processCategory();
    this.getCompetitorSet();
  },
  methods: {
    getCompetitorSet() {
      let self = this;
      let url = "/api/india_clinets/product_set_list_compare";
      let payload = {
        client: "maharaja",
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.competitorData = response.body.data.voc_product_list;
        },
        (err) => {
        }
      );
    },
    processCategory() {
      localStorage.demo_voc_channelSelector = this.channelSelector;
      this.itemCategory = [];
      if (localStorage.demo_voc_product_list)
        this.productList = JSON.parse(localStorage.demo_voc_product_list);
      for (let [i, k] of Object.keys(this.productList[this.channelSelector]).entries()) {
        this.itemCategory.push({ key: k, value: k.replace("_", " ") });
      }
      if (localStorage.demo_selectedItemCategory) {
        this.selectedItemCategory = {};
        for (let [i, k] of this.itemCategory.entries()) {
          if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
            this.selectedItemCategory = k;
          }
        }
        if (!Object.keys(this.selectedItemCategory).length) {
          this.selectedItemCategory = this.itemCategory[0];
        }
      } else this.selectedItemCategory = this.itemCategory[0];
      this.init();
    },
    icChanged() {
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
      this.init();
    },
    init() {
      this.nonPrimaryProductsOptions = [];
      this.primaryProductsOptions = [];
      this.products = [];
      this.selectedProducts = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let ci = 0;
      for (let [i, k] of this.productList[this.channelSelector][
        this.selectedItemCategory.key
      ].entries()) {
        let obj = {
          brand: "test",
          color: color[ci],
          forum: false,
          primary: k.primary,
          product_name: k.name,
        };
        if (k.primary) this.primaryProductsOptions.push(obj);
        else this.nonPrimaryProductsOptions.push(obj);
        if (ci == color.length - 1) ci = 0;
        else ci++;
      }
      this.products = [
        this.primaryProductsOptions[0],
        this.nonPrimaryProductsOptions[0],
        this.nonPrimaryProductsOptions[1],
      ];
      this.selectedProducts = [
        this.primaryProductsOptions[0].product_name,
        this.nonPrimaryProductsOptions[0].product_name,
        this.nonPrimaryProductsOptions[1].product_name,
      ];
      this.refresh();
    },

    refresh() {
      this.date = this.$refs.datecomponent.date;
      this.getData();
    },
    downloadExcel() {
      let self = this;
      this.loader = true;
      let url = "/api/reviews/reviewdownload";
      let payload = {
        start_date: this.date.startDate,
        end_date: this.date.endDate,
        product_list: this.selectedProducts,
      };
      this.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
        }
      );
    },
    createPdf() {
      let self = this;
      self.loader = true;
      let content = document.querySelector("#sentimentPdf");
      let canvasWidth = content.scrollWidth + 5;
      let canvasHeight = content.scrollHeight + 5;
      let options = {
        scale: 1.5,
        width: canvasWidth,
        onclone: function () {
          alert("Pdf generated. Download Now");
        },
      };
      setTimeout(function () {
        html2canvas(content, options).then((canvas) => {
          let imgData = canvas.toDataURL("image/jpeg", 1.0);
          let doc = new jsPDF("p", "mm", [canvasWidth, canvasHeight]);
          let pdfWidth = canvasWidth - 16;
          let pdfHeight = canvasHeight;
          doc.addImage(imgData, "JPEG", 8, 8, pdfWidth, pdfHeight);
          doc.save("voc_weavr_sentiment_" + moment().format("DDMMMYYYY") + ".pdf");
          self.loader = false;
        });
      }, 0);
    },
    changeProduct(ud, idx) {
      let self = this;
      if (idx == 0) {
        let isPrimary = false;
        let compData =
          self.competitorData[this.channelSelector][this.selectedItemCategory.key][
            self.selectedProducts[0]
          ];
        for (let [ci, cdata] of this.productList[this.channelSelector][
          this.selectedItemCategory.key
        ].entries()) {
          if (self.selectedProducts[0] == cdata.name) {
            if (cdata.primary) isPrimary = true;
          }
        }
        if (isPrimary) {
          self.selectedProducts[1] = compData.comp1;
          self.selectedProducts[2] = compData.comp2;
        }
      }
      self.products = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let cci = 0;
      for (let [pi, pdata] of this.selectedProducts.entries()) {
        for (let [ci, cdata] of this.productList[this.channelSelector][
          this.selectedItemCategory.key
        ].entries()) {
          if (pdata == cdata.name) {
            let obj = {
              brand: "test",
              color: color[cci],
              forum: false,
              primary: cdata.primary,
              product_name: cdata.name,
            };
            self.products.push(obj);
            if (cci == color.length - 1) cci = 0;
            else cci++;
          }
        }
      }
      self.refresh();
    },
    getKeywordChartData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      self.$nextTick(function () {
        self.keywordChartData = {};
        let url = "/api/reviews/keywisesentdata?interval=" + self.interval;
        url += "&keyword=" + self.modalTitle;
        url += "&product_name=" + self.modalProductName;
        if (self.channelSelector) url += "&channel=" + self.channelSelector;
        if (self.modalSentimentType) url += "&sentiment_type=" + self.modalSentimentType;
        if (this.date.startDate)
          url += "&start_date=" + this.date.startDate + "&end_date=" + this.date.endDate;
        self.$http.get(url).then(
          (response) => {
            self.keywordChartData = response.body;
            self.modalLoader = false;
            self.loader = false;
            self.processChartData();
          },
          (err) => {
            self.modalLoader = false;
            self.loader = false;
          }
        );
      });
    },
    processChartData() {
      let category = [];
      let series = [];
      let datakeys = [
        { key: "positive", label: "Positive", color: "green" },
        { key: "negative", label: "Negative", color: "red" },
      ];
      for (let [i, k] of datakeys.entries()) {
        if (this.keywordChartData.data[k.key]) {
          let obj = {};
          obj.name = k.label;
          obj.data = [];
          obj.color = k.color;
          for (let [idx, dataset] of this.keywordChartData.data[k.key].entries()) {
            category.push(dataset.date);
            obj.data.push(dataset[this.chartDataKey]);
          }
          series.push(obj);
        }
      }
      this.plotChart({ series: series, category: category });
    },
    plotChart(d) {
      var self = this;
      if (d.category.length) self.activeModalChart = true;
      else self.activeModalChart = false;
      this.modalChart = {
        credits: {
          enabled: false,
        },
        chart: {
          height: 210,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },

        yAxis: {
          title: {
            text: "",
          },
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            color: "rgba(166, 215, 238)",
            width: 2,
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y) + "</b> <br/>";
            }
            return mytooltip;
          },
          shared: true,
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 1.9,
            },
          },
        },
        series: d.series,
      };
    },
    refreshModal(k) {
      this.date = this.$refs[k].date;
      this.getKeywordChartData();
      this.getKeywordWiseData();
    },
    getKeywordWiseData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      let url = "/api/reviews/keywordwise";
      url += "?keyword=" + self.modalTitle;
      url += "&product_name=" + self.modalProductName;
      if (self.channelSelector) url += "&channel=" + self.channelSelector;
      if (self.modalSentimentType) url += "&sentiment_type=" + self.modalSentimentType;
      if (this.date.startDate)
        url += "&start_date=" + this.date.startDate + "&end_date=" + this.date.endDate;
      self.$http.get(url).then(
        (response) => {
          self.modalData = response.body;
          self.modalLoader = false;
          self.loader = false;
          if (!self.showModal) self.showModal = true;
        },
        (err) => {
          self.modalLoader = false;
          self.loader = false;
        }
      );
    },

    changeSentimentType(d) {
      this.$nextTick(function () {
        this.modalSentimentType = d;
        this.getKeywordWiseData();
      });
    },

    openModal(keyword, productName, type) {
      this.modalTitle = keyword;
      this.modalProductName = productName;
      this.modalSentimentType = type;
      this.refreshModal("datecomponent");
    },

    drawgauge(isRender, dataPositive, dataNegative, productName, keyword) {
      let self = this;
      let series = [];
      let value1 = Number(dataPositive);
      let value2 = Number(dataNegative);
      if (value1 && value2) {
        let obj = {};
        obj.name = "Positive";
        obj.color = "#7fc557";
        obj.y = value1;
        series.push(obj);
        let obj2 = {};
        obj2.name = "Negative";
        obj2.color = "#fb7b63";
        obj2.y = value2;
        series.push(obj2);
      } else {
        if (!value1) {
          let obj = {};
          obj.name = "Negative";
          obj.color = "#fb7b63";
          obj.y = value2;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "whitesmoke";
          obj2.y = 100 - value2;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
        if (!value2) {
          let obj = {};
          obj.name = "Positive";
          obj.color = "#7fc557";
          obj.y = value1;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "whitesmoke";
          obj2.y = 100 - value1;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
      }
      self.charts[productName] = {};
      self.$nextTick(function () {
        self.charts[productName][keyword] = {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
            margin: [0, 0, 0, 0],
            padding: [0, 0, 0, 0],
            height: 110,
            width: 180,
          },
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          accessibility: {
            point: {
              valueSuffix: "%",
            },
          },
          tooltip: {
            formatter() {
              if (this.point.name == "other") {
                return false;
              }
              var mytooltip = "";
              // console.log(this.point)
              mytooltip +=
                '<span style="color:' + this.point.color + '!important">\u25CF</span> ';
              mytooltip += this.point.name;
              mytooltip += " : <b> " + self.format(this.point.y) + "%</b> <br/>";
              return mytooltip;
            },
          },
          plotOptions: {
            series: {
              borderWidth: 0,
            },
            pie: {
              dataLabels: {
                enabled: true,
                distance: -15,
                format: "{point.y:.1f}",
                style: {
                  fontSize: 11,
                },
              },
              showInLegend: true,
              startAngle: -90,
              endAngle: 90,
              size: "100%",
              center: ["50%", "57%"],
            },
          },
          legend: {
            enabled: false,
            itemStyle: {
              fontSize: 9,
              fontWeight: 1,
            },
          },
          series: [
            {
              type: "pie",
              innerSize: "59%",
              data: series,
            },
          ],
        };
        self.$nextTick(function () {
          if (isRender) {
            self.renderChart = true;
          }
        });
      });
    },
    format(v) {
      return this.$options.filters.format(v);
    },
    plotWordCloud(product_name, type, data, min, max) {
      this.defaultWords[product_name] = {};
      this.defaultWords[product_name][type] = {};
      this.$nextTick(function () {
        this.defaultWords[product_name][type] = {
          chart: {
            height: 180,
          },
          credits: {
            enabled: false,
          },
          series: [
            {
              type: "wordcloud",
              data: data,
              name: "Frequency",
              rotation: {
                from: 0,
                to: 0,
                orientations: 1,
              },
              minFontSize: min,
              maxFontSize: max,
            },
          ],
          title: {
            text: "",
          },
        };
      });
    },
    drawTagCloud() {
      let self = this;
      this.renderCloud = false;
      for (const [pidx, d] of this.data.entries()) {
        let seriesPositiveData = [];
        let seriesNegativeData = [];
        for (const [idx, p] of d.data.positive.entries()) {
          let obj = {};
          obj.name = p.word;
          obj.weight = p.frequency;
          obj.Display = p.display;
          obj.score = this.$options.filters.format(p.compound_score);
          seriesPositiveData.push(obj);
        }
        this.plotWordCloud(d.product_name, "positive", seriesPositiveData, 10, 22);
        for (const [idx, p] of d.data.negative.entries()) {
          let obj = {};
          obj.name = p.word;
          obj.weight = p.frequency;
          obj.Display = p.display;
          obj.score = this.$options.filters.format(p.compound_score);
          seriesNegativeData.push(obj);
        }
        this.plotWordCloud(d.product_name, "negative", seriesNegativeData, 4, 8);
        this.$nextTick(function () {
          this.renderCloud = true;
        });
      }
    },

    processTable() {
      let self = this;
      let renderChart = true;
      for (let [idx, d] of this.tableData.entries()) {
        self.tableData[d.product_name] = d.data;
        console.log;
        for (let [y, td] of d.data.entries()) {
          if (idx == this.tableData.length - 1 && y == d.data.length - 1) {
            renderChart = true;
          }
          this.drawgauge(
            renderChart,
            td.positive_score,
            td.negative_score,
            d.product_name,
            td.word
          );
        }
      }
      //
    },
    getData() {
      this.modalLoader = true;
      this.loader = true;
      this.renderChart = false;
      this.data = [];
      this.defaultWords = {};
      this.date.from = moment(this.date.from).format("YYYY-MM-DD");
      this.date.to = moment(this.date.to).format("YYYY-MM-DD");
      let url =
        "/api/reviews/sentiment?client=maharaja&channel=" +
        this.channelSelector +
        "&products=" +
        this.selectedProducts;
      if (this.date.startDate)
        url += "&start_date=" + this.date.startDate + "&end_date=" + this.date.endDate;
      this.$http.get(url).then(
        (response) => {
          this.data = response.body.data;
          this.tableData = response.body.table;
          this.loader = false;
          this.modalLoader = false;
          if (this.data) {
            this.drawTagCloud();
            this.processTable();
          }
        },
        (err) => {
          this.loader = false;
          this.modalLoader = false;
        }
      );
    },
  },
};
</script>

<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.card_vivo {
  background-color: #0072ba !important;
  border: 1px solid #0072ba !important;
}
.card_realme {
  background-color: #f3b821 !important;
  border: 1px solid #f3b821 !important;
}
.card_redmi {
  background-color: #f56628 !important;
  border: 1px solid #f56628 !important;
}
.wordCloud {
  padding: 0;
  background: #f9f9f9;
  height: 150px !important;
}
.badge {
  padding: 5px;
  font-size: 13px;
}
.redbg {
  color: red;
  cursor: pointer;
}
.greenbg {
  color: green;
  cursor: pointer;
}
.highlight_primary {
  box-shadow: 0 0 0 0.2rem rgba(65, 181, 222, 0.5);
}
.highlight_success {
  box-shadow: 0 0 0 0.2rem rgba(104, 199, 137, 0.5);
}
.highlight_danger {
  box-shadow: 0 0 0 0.2rem rgba(249, 130, 129, 0.5);
}
.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}
.highcharts-figure .chart-container {
  width: 300px;
  height: 200px;
  float: left;
}
.datebox {
  width: 11% !important;
}
</style>
